import {
  Divider,
  Grid2,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";

const Section3 = () => {
  return (
    <>
      <Typography variant="h4" gutterBottom>
        Information Collected and Displayed
      </Typography>
      <Typography sx={{ fontSize: "1.1rem" }} variant="body1" mb={2}>
        The Application displays personal and employment-related information
        collected during employee onboarding and managed by the Human Resources
        Department through the HRMS web application. This data is synchronized
        with the mobile and desktop versions of the Application for operational
        use and employee reference.
      </Typography>
      <Typography variant="h4" gutterBottom>
        Personal Information
      </Typography>
      <Typography sx={{ fontSize: "1.1rem" }} variant="body1" mb={2}>
        The following personal details may be processed:
      </Typography>

      <Grid2 container spacing={2} ml={4} mb={2}>
        <Grid2 size={{ xs: 12 }}>
          <List sx={{ listStyleType: "disc", pl: 4 }}>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary="Full name"
                primaryTypographyProps={{
                  sx: { textAlign: "justify", fontSize: "1.1rem" },
                }}
              />
            </ListItem>

            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary="Date of birth"
                primaryTypographyProps={{
                  sx: { textAlign: "justify", fontSize: "1.1rem" },
                }}
              />
            </ListItem>

            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary="Gender"
                primaryTypographyProps={{
                  sx: { textAlign: "justify", fontSize: "1.1rem" },
                }}
              />
            </ListItem>

            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary="Marital status"
                primaryTypographyProps={{
                  sx: { textAlign: "justify", fontSize: "1.1rem" },
                }}
              />
            </ListItem>

            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary="Father’s name"
                primaryTypographyProps={{
                  sx: { textAlign: "justify", fontSize: "1.1rem" },
                }}
              />
            </ListItem>

            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary="Residential address"
                primaryTypographyProps={{
                  sx: { textAlign: "justify", fontSize: "1.1rem" },
                }}
              />
            </ListItem>

            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary="Mobile number"
                primaryTypographyProps={{
                  sx: { textAlign: "justify", fontSize: "1.1rem" },
                }}
              />
            </ListItem>

            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary="Official email address"
                primaryTypographyProps={{
                  sx: { textAlign: "justify", fontSize: "1.1rem" },
                }}
              />
            </ListItem>

            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary="Emergency contact detail"
                primaryTypographyProps={{
                  sx: { textAlign: "justify", fontSize: "1.1rem" },
                }}
              />
            </ListItem>
          </List>
        </Grid2>
      </Grid2>

      <Typography variant="h4" gutterBottom>
        Statutory and Government Identification
      </Typography>
      <Typography sx={{ fontSize: "1.1rem" }} variant="body1" mb={2}>
        For payroll and statutory compliance, the following identifiers may be
        processed:
      </Typography>

      <Grid2 container spacing={2} ml={4}>
        <Grid2 size={{ xs: 12 }}>
          <List sx={{ listStyleType: "disc", pl: 4 }}>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary="Aadhaar number"
                primaryTypographyProps={{
                  sx: { textAlign: "justify", fontSize: "1.1rem" },
                }}
              />
            </ListItem>

            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary="PAN number"
                primaryTypographyProps={{
                  sx: { textAlign: "justify", fontSize: "1.1rem" },
                }}
              />
            </ListItem>

            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary="UAN"
                primaryTypographyProps={{
                  sx: { textAlign: "justify", fontSize: "1.1rem" },
                }}
              />
            </ListItem>

            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary="ESIC number"
                primaryTypographyProps={{
                  sx: { textAlign: "justify", fontSize: "1.1rem" },
                }}
              />
            </ListItem>
          </List>
        </Grid2>
      </Grid2>

      <Typography sx={{ fontSize: "1.1rem" }} variant="body1" mb={2}>
        Employees do not independently submit or modify sensitive identification
        details through the mobile application. Such data is entered, maintained
        and controlled exclusively by authorized HR personnel through the HRMS
        web portal.
      </Typography>
      <Divider sx={{ my: 2 }} />
    </>
  );
};

export default Section3;
